require('../styles/modules/log.scss');
import React, { Component, PropTypes } from 'react'
import LogRecord from '../components/LogRecord'
import Answer from '../components/Answer'
import LogSubmission from '../components/LogSubmission'

class LogContainer extends Component {
  render() {
    const { data, loadState, isMobile, submitChallenge, pendingSolution, nextChallenge } = this.props
    let recordsShown = isMobile && !data.isChallenge ? -5 : -8
    let records = data.records.slice(recordsShown).reverse().map((recordProps, index)=>{
      return <LogRecord data = { recordProps } loadState = { loadState } key = { index } isActiveRecord = { (data.records.length - 1 - data.currentRecordIndex) === index }/>
    })
    let submission = !data.isChallenge ? "" :  <LogSubmission data = { data } submitChallenge = { submitChallenge } nextChallenge = { nextChallenge } />
    return (
      <div className = "log-container">
        <Answer data = {{ solution: pendingSolution }} />
        { data.isChallenge ? <Answer data = { data.records[data.currentRecordIndex] } /> : '' }
        <div className = "flex-box robots-container flex-wrap">
          { records }
        </div>
        { submission }
      </div>
    )
  }
}

LogContainer.propTypes = {
  
}

export default LogContainer



// WEBPACK FOOTER //
// ./containers/LogContainer.js